import {
  Sun,
  Cloud,
  CloudSun,
  CloudRain,
  CloudDrizzle,
  CloudSnow,
  CloudLightning,
  CloudFog,
} from 'lucide-react';
import { WeatherDetails } from './types';

export const getWeatherDetails = (code: number): WeatherDetails => {
  switch (code) {
    case 0:
      return {
        description: 'Musaffo osmon',
        icon: Sun,
        color: 'text-yellow-400 animate-pulse',
      };
    case 1:
      return {
        description: 'Asosan ochiq',
        icon: CloudSun,
        color: 'text-yellow-300',
      };
    case 2:
      return {
        description: 'Qisman bulutli',
        icon: CloudSun,
        color: 'text-zinc-300',
      };
    case 3:
      return {
        description: 'Bulutli',
        icon: Cloud,
        color: 'text-zinc-400',
      };
    case 45:
    case 48:
      return {
        description: 'Tuman',
        icon: CloudFog,
        color: 'text-zinc-500',
      };
    case 51:
    case 53:
    case 55:
      return {
        description: 'Maydalab yog‘ayotgan yomg‘ir',
        icon: CloudDrizzle,
        color: 'text-blue-300 animate-pulse',
      };
    case 56:
    case 57:
      return {
        description: 'Muzli mayda yomg‘ir',
        icon: CloudSnow,
        color: 'text-blue-200',
      };
    case 61:
      return {
        description: 'Yengil yomg‘ir',
        icon: CloudRain,
        color: 'text-blue-400',
      };
    case 63:
      return {
        description: 'O‘rtacha yomg‘ir',
        icon: CloudRain,
        color: 'text-blue-500',
      };
    case 65:
      return {
        description: 'Kuchli yomg‘ir',
        icon: CloudRain,
        color: 'text-blue-600 animate-bounce',
      };
    case 66:
    case 67:
      return {
        description: 'Muzli yomg‘ir',
        icon: CloudSnow,
        color: 'text-blue-300',
      };
    case 71:
      return {
        description: 'Yengil qor',
        icon: CloudSnow,
        color: 'text-white',
      };
    case 73:
      return {
        description: 'O‘rtacha qor',
        icon: CloudSnow,
        color: 'text-zinc-100',
      };
    case 75:
      return {
        description: 'Kuchli qor',
        icon: CloudSnow,
        color: 'text-zinc-200',
      };
    case 77:
      return {
        description: 'Qor donachalari',
        icon: CloudSnow,
        color: 'text-zinc-300',
      };
    case 80:
    case 81:
    case 82:
      return {
        description: 'Qisqa muddatli yomg‘ir',
        icon: CloudRain,
        color: 'text-blue-400',
      };
    case 85:
    case 86:
      return {
        description: 'Qisqa muddatli qor',
        icon: CloudSnow,
        color: 'text-zinc-100',
      };
    case 95:
      return {
        description: 'Momaqaldiroq',
        icon: CloudLightning,
        color: 'text-amber-500',
      };
    case 96:
    case 99:
      return {
        description: 'Do‘l aralash momaqaldiroq',
        icon: CloudLightning,
        color: 'text-amber-600',
      };
    default:
      return {
        description: 'Quyoshli',
        icon: Sun,
        color: 'text-yellow-400',
      };
  }
};
